import { render } from "./OverlayThermography.vue?vue&type=template&id=37033122&scoped=true"
import script from "./OverlayThermography.vue?vue&type=script&lang=js"
export * from "./OverlayThermography.vue?vue&type=script&lang=js"

import "./OverlayThermography.vue?vue&type=style&index=0&id=37033122&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37033122"]])

export default __exports__